import { useState } from "react";
import { ModalState } from "../types";
import { INITIAL_MODAL_STATE } from "../constants";

export const useModalState = () => {
  const [modalState, setModalState] = useState<ModalState>(INITIAL_MODAL_STATE);

  const toggleModal = (modalKey: keyof ModalState) => {
    setModalState((prevState) => ({
      ...prevState,
      [modalKey]: !prevState[modalKey],
    }));
  };

  const closeModal = (modalKey: keyof ModalState) => {
    setModalState((prevState) => ({
      ...prevState,
      [modalKey]: false,
    }));
  };

  const openModal = (modalKey: keyof ModalState) => {
    setModalState((prevState) => ({
      ...prevState,
      [modalKey]: true,
    }));
  };

  const closeAllModals = () => {
    setModalState(INITIAL_MODAL_STATE);
  };

  return {
    modalState,
    toggleModal,
    closeModal,
    openModal,
    closeAllModals,
  };
};
